import { Button, Card, Form, Input } from 'antd';
import { FilterGroup, Grid } from '../../../models';
import { useEffect, useState } from 'react';
import { IntegrationSchedulesForm } from './integration-schedules-form';
import { FilterSelector } from '../../../elements';

export function EditIntegrationExportFilterPage(props: { filter?: any; onSaved: (formData: any) => void; grid?: Grid; filters?: any[] }) {
  const [form] = Form.useForm();
  const [integration, setIntegration] = useState<any>();
  const [filterGroup, setFilterGroup] = useState<FilterGroup>();

  useEffect(() => {
    if (!props.filter) {
      return;
    }
    setIntegration(props.filter);
  }, [props.filter]);

  useEffect(() => {
    if (!integration) {
      return;
    }

    form.setFieldsValue({
      cronStrings: integration.cronStrings,
      filterName: integration.filterName,
    });
  }, [form, integration]);

  const onFinish = (values: any) => {
    const filterRules = values.filter as any[];
    const cronStrings = values.cronStrings as string[];
    const filterName = values.filterName as string;

    const body = { cronStrings, filterRules, filterName, filterGroup };

    body.filterRules = body.filterRules.map((r: any) => {
      let value = r.value === '###true###' ? true : r.value === '###false###' ? false : r.value;
      return {
        fieldId: r.fieldId,
        op: r.op === 'change_start_date' ? '==' : r.op,
        value,
        previousRevisions: r.previousRevisions,
      };
    });

    props.onSaved(body);
  };

  return (
    <Form name="basic" form={form} onFinish={onFinish}>
      <Form.Item
        required
        label="Filtre Adı"
        name={'filterName'}
        validateTrigger={['onChange', 'onBlur']}
        rules={[
          {
            required: true,
            message: 'Zorunlu alan',
          },
          {
            validator: async (_, value) => {
              const filterNames = props.filters?.map(f => f.filterName);
              const filterNamesExceptCurrent = filterNames?.filter(f => f !== props.filter?.filterName);

              if (filterNamesExceptCurrent?.includes(value)) {
                return Promise.reject(new Error('Bu isimde bir filtre zaten var'));
              }
            },
          },
        ]}
      >
        <Input placeholder="Filtre adı" />
      </Form.Item>

      <Card title="Filtreler">
        <FilterSelector
          dataSetId={props.grid?.id}
          value={
            props.filter?.filterGroup
              ? typeof props.filter.filterGroup === 'string'
                ? JSON.parse(props.filter.filterGroup)
                : props.filter.filterGroup
              : undefined
          }
          onChange={value => setFilterGroup(value)}
        />
      </Card>

      <Card title="Otomatik çalıştırma" style={{ marginTop: '3rem' }}>
        <Form.Item name={'cronStrings'}>
          <IntegrationSchedulesForm integrationType="export" />
        </Form.Item>
      </Card>

      <div style={{ marginTop: '3rem', display: 'flex', justifyContent: 'flex-end' }}>
        <Button type="primary" htmlType="submit">
          Kaydet
        </Button>
      </div>
    </Form>
  );
}
